import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import { errorDispatch } from "../../../functions/errorDispatch";

export default {
  props: {
    folderId: String,
    mySpace: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      id: this.$options.name,
      error: false,
    };
  },
  created() {
    EventBus.$on(`${this.id}-show`, (data) => {
      //show this overlay
      EventBus.$emit("openOverlayPage", data);
    });

    EventBus.$on(`${this.id}-add`, (data) => {
      this.addFolder(data);
    });
  },
  methods: {
    addFolder(data) {
      const formData = new FormData(this.$refs.addFolderForm);

      if (data.mySpace === 1) {
        //is my space
        formData.append("folder", "null");
      } else {
        //is other space
        formData.append("folder", data.id ? data.id : data.folderId);
        formData.append("description", "");
        formData.append("color", "000");
        formData.append("private", false);
      }

      formData.append("myspace", data.mySpace);

      this.$axios
        .post(baseUrl + "/folderadd", formData)
        .then((r) => {
          //close overlay
          EventBus.$emit("closeOverlayPage", { id: this.$options.name });

          if (r.data.success == false && r.data.msg == "folder_exists") {
            this.error = true;
          }
          if (r.data.success == true && r.data.msg == "folder_added") {
            this.$router.push(
              `/${this.$store.state.company}/${
                data.mySpace === 1 ? "myspace" : "home"
              }/expanded/${r.data.folder_id}`
            );
          }
        })
        .catch((e) => {
          errorDispatch("add_folder");
        });
    },
  },
};
